/**
 * Console layout (P26).
 *
 * Wireframe used a single state-managed page; we use React Router. The
 * shell is the same: `.console-shell` is the CSS grid (sidebar + workspace)
 * defined in `apps/web/src/styles/index.css` (lifted from the wireframe).
 */
import type { JSX } from 'react';
import { Outlet } from 'react-router-dom';

import { BreadcrumbProvider } from './BreadcrumbContext.js';
import { SessionExpiryBanner } from './SessionExpiryBanner.js';
import { Sidebar } from './Sidebar.js';
import { TopBar } from './TopBar.js';

export function ConsoleLayout(): JSX.Element {
  return (
    <BreadcrumbProvider>
      <div className="console-shell">
        <Sidebar />
        <div className="workspace">
          <TopBar />
          <SessionExpiryBanner />
          <main className="page-canvas" id="main-content">
            <Outlet />
          </main>
        </div>
      </div>
    </BreadcrumbProvider>
  );
}
